import store from 'store2';
export var $localStorage = store;